import { useEffect, useState, useReducer } from "react";
import { hasPermission } from "./permissions";

export default (fn, { permission = undefined, minimumTime = undefined } = {}) => {
  const [loaded, onLoaded] = useReducer(() => true, false),
    [error, onError] = useState(false),
    // We can use hasPermission here dynamically as
    // permission should be static
    permitted = permission ? hasPermission(permission) : true;

  const doAttempt = async () => fn();

  useEffect(() => {
    if (!permitted) {
      // Nothing to do
      return undefined;
    }

    const start = Date.now();
    let active = true;

    const runAttempts = async (remaining = 5) => {
      if (!active) {
        return;
      }
      if (remaining < 0) {
        throw new Error("Failed to load");
      }
      return doAttempt()
        .catch((error) => {
          if (remaining === 0) {
            return Promise.reject(error);
          }
          return runAttempts(remaining - 1);
        });
    };

    const onLoadedWithMinimum = async () => {
      if (!minimumTime || minimumTime < 0) {
        return onLoaded();
      }
      const difference = Date.now() - start;
      const remaining = minimumTime - (((difference / minimumTime) - Math.floor(difference / minimumTime)) * minimumTime);
      if (remaining > 0) {
        await new Promise(resolve => setTimeout(resolve, remaining));
      }
      return onLoaded();
    };

    runAttempts(5)
      .then(onLoadedWithMinimum)
      .catch(onError);

    return () => {
      active = false;
    };
  });

  return { loaded: !permitted || loaded, error };
}



// WEBPACK FOOTER //
// ./src/services/use-loader.js